module.exports = __webpack_public_path__ + "img/ib.fb796a5a.jpeg";